/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Ornate_Jackdaw_AidInputs */

const fr_simple_ornate_jackdaw_aid = /** @type {(inputs: Simple_Ornate_Jackdaw_AidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine du`)
};

/**

* @param {Simple_Ornate_Jackdaw_AidInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const simple_ornate_jackdaw_aid = /** @type {((inputs?: Simple_Ornate_Jackdaw_AidInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Ornate_Jackdaw_AidInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_simple_ornate_jackdaw_aid(inputs)
});